import React, { useState } from "react";
import axios from "axios";
import SectionTitle from "../../../assets/components/TitleGroup";
import PlaceholderB from "../../../assets/components/PlaceholderB";
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import { useFixedLayout } from "../../../hooks/useFixedLayout";

const AdsRegistConciergeFindPin = ({
  phone,
  setPhone,
  pin,
  setPin,
  goToStep,
  targetConciergeVerify,
}) => {
  const { footerRef, bottomSpace } = useFixedLayout();
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);

  const isDisabled = !name.trim() || phone.replace(/\D/g, "").length < 10;

  const handleFindPin = async () => {
    if (loading || isDisabled) return;

    setLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_FASTAPI_SEVER_URL}/concierge/user/find-pin`,
        {
          name: name.trim(),
          phone: phone.replace(/\D/g, ""),
        },
        { headers: { "Content-Type": "application/json" } }
      );

      const foundPin = String(res?.data?.pin || "").replace(/\D/g, "");
      setPin(foundPin);
      window.alert(foundPin ? `현재 PIN 번호는 ${foundPin} 입니다.` : "PIN 번호를 찾지 못했습니다.");
      goToStep(targetConciergeVerify);
    } catch (error) {
      window.alert(
        error?.response?.data?.detail ||
          error?.response?.data?.message ||
          "PIN 번호를 찾지 못했습니다."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex h-full flex-col">
      <div
        className="flex flex-1 flex-col px-[16px] pt-[16px]"
        style={{ paddingBottom: bottomSpace }}
      >
        <SectionTitle
          title="PIN 번호 찾기"
          subTitle="컨시어지 가입 시 등록한 이름과 휴대폰번호를 입력해 주세요."
          className="pb-[40px]"
        />

        <div className="space-y-[12px]">
          <PlaceholderB
            label="이름"
            required
            placeholder="이름을 입력해 주세요"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <PlaceholderB
            label="휴대폰번호"
            required
            placeholder="숫자만 입력해 주세요"
            type="tel"
            inputMode="numeric"
            pattern="[0-9]*"
            value={phone}
            onChange={(e) =>
              setPhone(e.target.value.replace(/[^0-9]/g, "").slice(0, 11))
            }
          />
          {pin ? (
            <div className="rounded-[16px] bg-[#F5F3FF] px-[16px] py-[14px] text-b1 text-[#5B21B6]">
              현재 PIN 번호: <span className="font-semibold">{pin}</span>
            </div>
          ) : null}
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SplitRowHalf
          leftText="이전"
          rightText={loading ? "조회 중..." : "조회"}
          leftType="border"
          rightType="fill"
          onLeft={() => goToStep(targetConciergeVerify)}
          onRight={handleFindPin}
          rightDisabled={loading || isDisabled}
        />
      </div>
    </div>
  );
};

export default AdsRegistConciergeFindPin;
